import produce from 'immer';
import {State, Actions} from './interfaces';
import {
  GET_BUNDLES,
  GET_BUNDLES_SUCCESS,
  GET_BUNDLES_FAILED,
  GET_BUNDLE_WITH_ID,
  GET_BUNDLE_WITH_ID_SUCCESS,
  GET_BUNDLE_WITH_ID_FAILED,
  GET_LOGS,
  GET_LOGS_SUCCESS,
  GET_LOGS_FAILED,
  GET_ALL_BUNDLES,
  GET_ALL_BUNDLES_SUCCESS,
  GET_ALL_BUNDLES_FAILED,
  CLEAR_BUNDLE
} from './constants';

export const initialState: State = {
  bundlesList: [],
  allBundlesList: [],
  bundle: {},
  logs: [],
  count: 0,
  loading: false,
  error: '',
};

export const BundlesReducer = (state = initialState, action: Actions) =>
  produce(state, draft => {
    switch (action.type) {
      case GET_BUNDLES:
        draft.loading = true;
        break;
      case GET_BUNDLES_SUCCESS:
        draft.bundlesList = action.data;
        draft.allBundlesList = [];
        draft.count = action.count;
        draft.loading = false;
        break;
      case GET_BUNDLES_FAILED:
        draft.error = action.error;
        draft.loading = false;
        break;

      case GET_ALL_BUNDLES:
        draft.loading = true;
        break;
      case GET_ALL_BUNDLES_SUCCESS:
        draft.allBundlesList = action.data;
        draft.loading = false;
        break;
      case GET_ALL_BUNDLES_FAILED:
        draft.error = action.error;
        draft.loading = false;
        break;
      case GET_BUNDLE_WITH_ID:
        draft.loading = true;
        break;
      case GET_BUNDLE_WITH_ID_SUCCESS:
        draft.bundle = action.data;
        draft.loading = false;
        break;
      case GET_BUNDLE_WITH_ID_FAILED:
        draft.error = action.error;
        draft.loading = false;
        break;
      case GET_LOGS:
        draft.loading = true;
        break;
      case GET_LOGS_SUCCESS:
        draft.logs = action.data;
        draft.loading = false;
        break;
      case GET_LOGS_FAILED:
        draft.error = action.error;
        draft.loading = false;
        break;

      case CLEAR_BUNDLE:
        draft.bundle = {}
        break;

      default:
        break;
    }
  });
export default BundlesReducer;
